import React from 'react';
import styled from 'styled-components';

interface MaybeLinkProps {
  children: React.ReactNode;
  ctaUrl?: string;
  fullWidth: boolean;
}

export const MaybeLink: React.FC<MaybeLinkProps> = ({
  children,
  ctaUrl,
  fullWidth,
}: MaybeLinkProps) => {
  return ctaUrl ? (
    <CustomLink data-testid="Banner__link" href={ctaUrl} target="_self" fullWidth={fullWidth}>
      {children}
    </CustomLink>
  ) : (
    children
  );
};

const CustomLink = styled.a<{ fullWidth: boolean }>`
  ${(props) => props.fullWidth && 'width: 100%;'}
`;
